import VerofreshRecord from './VerofreshRecord'
import Moment from 'moment'
import { filter, sortBy, last } from 'lodash'

class RoutePlanRecord extends VerofreshRecord {
  // eslint-disable-next-line
  get unregistered_locations () {
    return filter(this.route_plan_locations, x => x.location_id == null)
  }

  /**
   * Gets the route plan's duration as a Moment Duration object.
   * @returns Moment.Duration
   */
  get duration () {
    const start = Moment(this.start)
    let end = Moment(this.stop)

    if (start.isBefore() && !end.isValid()) {
      end = Moment()
    }

    if (!start.isValid() || !end.isValid()) {
      return undefined
    }

    return Moment.duration(end.diff(start))
  }

  /**
   * A sort of workaround function to deal with the fact that still let route plans bind to multiple routes but
   * generally only care about the newest route. Of all routes associated with this route plan, returns the one with
   * the latest start time.
   */
  get mostRecentRoute () {
    if (this.routes) {
      return last(sortBy(this.routes, x => x.start))
    }
    return undefined
  }
}

const relations = {
  hasMany: {
    RoutePlanLocation: {
      foreignKey: 'route_plan_id',
      localField: 'route_plan_locations'
    }
  }
}

export default RoutePlanRecord
export { relations }
